const VideoScheduleEnums = {
  Now: 1,
  FifteenMinPriorToSession: 2,
  Custom: 3,
  UnPublished: 4,
};


export default Object.freeze(VideoScheduleEnums);
